import { Dispatch, SetStateAction, useCallback, useEffect, useState } from 'react';
import { ComponentSize, FolderHierarchy } from '../../../types';
import { Spinner } from '../Spinner';
import FolderTreeItem from './FolderTreeItem';

interface FolderTreeProps {
  folders: FolderHierarchy[];
  selectedFolderId: string | null;
  setSelectedFolderId: Dispatch<SetStateAction<string | null>>;
  isLoading?: boolean;
  openFolderIds?: string[];
}

const FolderTree = ({
  folders,
  selectedFolderId,
  setSelectedFolderId,
  isLoading,
  openFolderIds: openFolderIdsProp,
}: FolderTreeProps) => {
  const [openFolderIds, setOpenFolderIds] = useState<string[]>([]);

  const toggleOpenFolder = useCallback(
    (id: string) =>
      setOpenFolderIds((prev) => (prev.includes(id) ? prev.filter((prevId) => prevId !== id) : [...prev, id])),
    [setOpenFolderIds]
  );

  const toggleSelectFolder = useCallback(
    (id: string) => setSelectedFolderId((prev) => (prev === id ? null : id)),
    [setSelectedFolderId]
  );

  // If the openFolderIdsProp is provided, initialize the openFolderIds state with it.
  useEffect(() => {
    if (!openFolderIds.length) {
      setOpenFolderIds(openFolderIdsProp || []);
    }
  }, [openFolderIdsProp]);

  return (
    <div className="flex h-full flex-col gap-2 overflow-x-auto">
      {isLoading && <Spinner className="h-full self-center" size={ComponentSize.MEDIUM} />}
      {!isLoading &&
        folders.map((folder) => (
          <FolderTreeItem
            key={folder.id}
            folders={folder.children || []}
            id={folder.id}
            level={0}
            name={folder.name}
            selected={selectedFolderId}
            toggleSelectFolder={toggleSelectFolder}
            toggleOpenFolder={toggleOpenFolder}
            openFolderIds={openFolderIds}
          />
        ))}
    </div>
  );
};

export default FolderTree;
